import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  inject,
  OnInit,
} from '@angular/core';
import { LoyaltyProgramApiService } from '@features/loyalty-program/services/loyalty-program-api/loyalty-program-api.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CmsFacade } from '@rd/cms/facades/cms.facade';
import { WindowRefService } from '@rd/core/services/window-ref/window-ref.service';
import { ENV, TENANT_NAME } from '@rd/core/tokens/rd-lib.token';
import { LoyaltyProgram } from '@rd/types';
import { CampaignBanner, CmsPageContentType } from '@rd/types/cms.type';
import { isNotNull } from '@rd/utils/isNotNull';
import { getUrlParamId } from '@rd/wl/anz/utils/anz-page-discovery.utils';
import { AnzEnvironmentType } from 'global-types';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'anz-campaign-banner-tc-details',
  templateUrl: './campaign-banner-tc-details.component.html',
  styleUrls: ['./campaign-banner-tc-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzCampaignBannerTCDetailsComponent implements OnInit {
  private cmsFacade = inject(CmsFacade);

  campaignBanner: CampaignBanner | null = null;
  showBanner: boolean;

  constructor(
    private cdr: ChangeDetectorRef,
    private windowRefService: WindowRefService,
    private loyaltyProgramApiService: LoyaltyProgramApiService,
    @Inject(TENANT_NAME) private tenantName: string,
    @Inject(ENV) private env: AnzEnvironmentType,
  ) {}

  ngOnInit(): void {
    this.getLoyaltyProgramUsingId()
      .pipe(untilDestroyed(this))
      .subscribe((loyaltyProgram: LoyaltyProgram) => {
        if (loyaltyProgram) {
          this.getCampaignBanner(loyaltyProgram.transferConnectIdentifier);
        }
      });
  }

  private getCampaignBanner(loyaltyProgramId: string): void {
    const bannerId = `${
      this.tenantName
    }--${loyaltyProgramId.toLowerCase()}-campaign-banner-tc-details`;

    this.cmsFacade
      .getContentByName({
        pageName: bannerId,
        pageType: 'campaignbanner',
        locale: 'en-au',
      })
      .pipe(untilDestroyed(this), filter(isNotNull))
      .subscribe((campaignBanner: CmsPageContentType) => {
        if (campaignBanner.type === 'campaignbanner') {
          this.campaignBanner = campaignBanner;
          // We should rename showBanner flag to showBannerInProduction
          // We will do this later as this affect the campaigns in production
          this.showBanner =
            this.env === 'production' ? this.campaignBanner?.showBanner : true;
          this.cdr.markForCheck();
        }
      });
  }

  private getLoyaltyProgramUsingId(): Observable<LoyaltyProgram> {
    return this.loyaltyProgramApiService.getLoyaltyProgram(
      getUrlParamId(this.windowRefService.nativeWindow.location.href),
    );
  }
}
